export default __webpack_public_path__ + "images/41e065cd511e386f8e1701f01f990d7d.png";